import { Button, Tooltip } from 'antd'
import { Paperclip } from 'lucide-react'
import { useRef } from 'react'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { CHAT_ATTACHMENT_ACCEPT } from './attachments'

const ICON_SIZE = 15

type Props = {
  onFiles: (files: File[]) => void
  disabled?: boolean
}

export const ChatAttachButton = ({ onFiles, disabled }: Props) => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const label = t('workspaceHome.attachments.attach')

  const onPick = (event: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files ?? [])

    // Picking the same file twice in a row must fire `change` again.
    event.target.value = ''

    if (files.length) onFiles(files)
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        accept={CHAT_ATTACHMENT_ACCEPT}
        onChange={onPick}
      />
      <Tooltip title={label}>
        <Button
          type="text"
          size="small"
          icon={<Paperclip size={ICON_SIZE} />}
          aria-label={label}
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
        />
      </Tooltip>
    </>
  )
}
